/**
 * Rest mechanics rules.
 * See: RESTING.md for rest type definitions.
 */

export const REST_RULES = {
  snackBreak: {
    resilienceRecovery: 2,
    strainRemoval: 1,
  },
  mealBreak: {
    resilienceRecovery: 'full' as const,
    strainRemoval: 'full' as const,
  },
  fullRest: {
    resilienceRecovery: 'full' as const,
    strainRemoval: 'full' as const,
    hpRecovery: 'resilience-roll' as const,
  },
} as const;
